/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineExTankService() {
        let exTankService = {};
        exTankService.getExTankOrders = function (request) {
            return axios.post("/api/ExTankService/GetExTankOrders", request);
        };
        exTankService.getExTankOrder = function (orderExTankId) {
            return axios.get("/api/ExTankService/GetExTankOrder?orderExTankId=" + orderExTankId);
        };
        exTankService.getExTankOrderByOrderId = function (orderId) {
            return axios.get("/api/ExTankService/GetExTankOrderByOrderId?orderId=" + orderId);
        };
        exTankService.addOrUpdateExTankOrder = function (request) {
            return axios.post("/api/ExTankService/AddOrUpdateExTankOrder", request);
        };
        exTankService.markOrderExTankAsUplifted = function (formData) {
            return axios.post("/api/ExTankService/MarkOrderExTankAsUplifted", formData, { headers: {'Content-Type': 'multipart/form-data' }});
        };
        exTankService.getExTankCompanyProductPricesForZone = function (request) {
            return axios.post("/api/ExTankService/GetExTankCompanyProductPricesForZone", request);
        };
        return exTankService;
    }
    //define globally if it doesn't already exist
    if (typeof (exTankService) === "undefined") {
        window.exTankService = defineExTankService();
    } else {
        console.log("exTankService already defined.");
    }
})(window);